import { toast } from "react-toastify";
import WhatsMarked from "react-whatsmarked";

const getTicketIdFromUrl = () => {
	const match = window.location.pathname.match(/\/tickets\/(\d+)/);
	return match ? match[1] : null;
};

const toastError = (err, t) => {
	const errorMsg =
		err?.response?.data?.message || err?.response?.data?.error;

	const ticketId = getTicketIdFromUrl();
	const ticketSuffix = ticketId ? ` (Ticket #${ticketId})` : "";

	if (errorMsg) {
		let translatedMsg = errorMsg;

		if (typeof t === "function") {
			// Alguns erros trazem dados extras após a chave (ex: "ERR_OPEN_USER_TICKET Gabriela").
			// Tenta traduzir a chave base e concatena o restante.
			const spaceIdx = errorMsg.indexOf(" ");
			const baseKey = spaceIdx !== -1 ? errorMsg.slice(0, spaceIdx) : errorMsg;
			const extra = spaceIdx !== -1 ? errorMsg.slice(spaceIdx + 1) : "";

			const fullKey = `backendErrors.${errorMsg}`;
			const baseTranslatedKey = `backendErrors.${baseKey}`;

			if (t(fullKey) !== fullKey) {
				translatedMsg = t(fullKey);
			} else if (extra && t(baseTranslatedKey) !== baseTranslatedKey) {
				translatedMsg = t(baseTranslatedKey) + extra;
			} else {
				translatedMsg = errorMsg;
			}
		}

		toast.error(<WhatsMarked>{translatedMsg + ticketSuffix}</WhatsMarked>, {
			toastId: errorMsg,
		});
	} else if (err?.message) {
		toast.error(<WhatsMarked>{err.message + ticketSuffix}</WhatsMarked>, {
			toastId: err.message,
		});
	} else {
		const fallbackMsg =
			typeof t === "function" &&
			t("backendErrors.genericError") !== "backendErrors.genericError"
				? t("backendErrors.genericError")
				: "An unexpected error occurred!";

		toast.error(<WhatsMarked>{fallbackMsg + ticketSuffix}</WhatsMarked>, {
			toastId: "genericError",
		});
	}
};

export default toastError;
